import React, { useRef, useState } from 'react';
import FoldableTableHOC from 'react-table/lib/hoc/foldableTable';
import ReactTable from 'react-table';
import { connect } from 'react-redux';
import { OuterComponent, PaddedContainer } from '../customer-support/StyledComponent';
import { SearchBox } from '../cashless-vaccination/styled-elements';
import NavBar from '../layout/NavBar';
import { ButtonGroup, Row } from 'reactstrap';
import { SearchBoxContent, SearchBoxInput } from '../cashless-vaccination/styled-elements';
import LoadingComponent from '../common/LoadingComponent';
import { FaSearch } from 'react-icons/fa';
import { cancelDentalModal, changeDentalCenter, confirmAppointmentAPI, fetchDentalCenterAndDoctorLists, getCashlessDentalRequests, getTimeSlots, markAppointmentComplete, rescheduleAppointment } from '../../services/api/cashless-dentals';
import tableColumns from './DentalTable';
import DentalRequestDetails from './Modals/DentalRequestsDetails';
import { hideDentalRequestModal, showDentalRequestModal } from '../../actions';
import SubContainer from '../cashless-vaccination/components/SubContainer';
import useAfterInitialEffect from '../cashless-vaccination/hooks/useAfterInitialEffect';
import DentalCommentModal from './Modals/DentalCommentModal';
import moment from 'moment';
import DentalModalCancellation from './Modals/CancelModal';
import { toast } from 'react-toastify';
import DownloadCsv from '../common/DownloadCsv';
import MarkDentalAppointmentComplete from './Modals/ConfirmModal';
import DentalClaimModal from './Modals/DentalClaimModal';
import ConfirmAppointmentModal from './Modals/ConfirmAppointmentModal';
import RescheduleAppointmentModal from './Modals/RescheduleAppointmentModal';
import ChangeCentreModal from './Modals/ChangeCentreModal';
import SpocActivityModal from './Modals/SpocActivityModal';

const FoldableTable = FoldableTableHOC(ReactTable);

const initialDates = {
    startDate: null,
    endDate: null,
}

const CashlessDental = ({
    dispatch,
    cashlessDentalDetails: stateDetails
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [ data, setData ] = useState([]);
    const [ makeSearch, setMakeSearch ] = useState('');
    const [ totalRecords, setTotalRecords ] = useState(0);
    const [ sponsorFilter, setRequestSponsorFilter ] = useState('');
    const [ partnerNameFilter, setPartnerNameFilter ] = useState('');
    const [mdpAppointmentFilter, setRequestMdpAppointmentFilter] = useState('');
    const [ requestIdFilter, setRequestIdFilter ] = useState('');
    const [cancelModalIsOpen, setCancelModalIsOpen] = useState(false);
    const [confirmModalIsOpen, setConfirmModalIsOpen] = useState(false);
    const [ statusFilter, setStatusFilter ] = useState('');
    const [ appTimeFilter, setAppTimeFilter ] = useState('');
    const [appointmentDateFilter, setAppointmentDateFilter] = useState(initialDates)
    const [requestDateFilter, setRequestDateFilter] = useState(initialDates)
    const [ pages, setPages ] = useState(0);
    const [ pageSize, setPageSize ] = useState(20)
    const [ currentPage, setCurrentPage ] = useState(0);
    const [ showSpocActivity, setShowSpocActivity ] = useState(false);
    const [ showCommentModal, setShowCommentModal ] = useState(false);
    const [ commentModalRequestId, setCommentModalRequestId ] = useState(null);
    const [requestId, setRequestId] = useState(null);
    const [mdpRequestId, setMdpRequestId] = useState(null);
    const [showClaimModal, setShowClaimModal] = useState(false);
    const [claimRequestId, setClaimRequestId] = useState(null);
    
    const [confirmAppointmentModalOpen, setConfirmAppointmentModalOpen] = useState(false);

    const [rescheduleModalOpen, setRescheduleModalOpen] = useState(false);
    const [selectedAppointment, setSelectedAppointment] = useState(null);
    const [availableSlotsData, setAvailableSlotsData] = useState(null);
    const [isLoadingSlots, setIsLoadingSlots] = useState(false);
    const [slotsError, setSlotsError] = useState(null);

    const [centresAndDoctorsData, setCentresAndDoctorsData] = useState([]);

    const [changeCentreModalOpen, setChangeCentreModalOpen] = useState(false);
    const [isLoadingChangeCentre, setIsLoadingChangeCentre] = useState(false);

    const searchInputRef = useRef(null)
    const isProcessingRef = useRef(false);



    
    const openConfirmAppointmentModal = (rowData) => {
        console.log('Opening confirm appointment modal:', rowData);
        setSelectedAppointment({
            rid: rowData.requestId || rowData.rid || '',
            patientName: rowData.patientName || rowData.userName || '',
            partner: rowData.sponsorName || rowData.partner || '',
            centre: rowData.centerName || rowData.centre || '',
            address: rowData.centerLocation || rowData.centerAddress || '',
            doctor: rowData.doctorName || rowData.doctor || '',
            age: rowData.age || rowData.patientAge || '',
            gender: rowData.gender || rowData.patientGender || '',
            appointmentDate: rowData.appointmentDate || rowData.date || '',
            appointmentTime: rowData.appointmentTime || rowData.time || '',
            mdpAppointmentId: rowData.mdpAppointmentId || '',
            slotId: rowData.slotId||"",
            partnerId: rowData.partnerId ||""
        });
        
        setConfirmAppointmentModalOpen(true);
    };

    const openRescheduleAppointmentModal = async(rowData) => {
        // console.log('Opening reschedule modal:', rowData);
        
        setSelectedAppointment({
            rid: rowData.requestId || rowData.rid || '',
            patientName: rowData.patientName || rowData.userName || '',
            partner: rowData.sponsorName || rowData.partner || '',
            center: rowData.centerName || rowData.centre || '',
            address: rowData.centerAddress || rowData.centerLocation || '',
            doctor: rowData.doctorName || rowData.doctor || '',
            age: rowData.age || rowData.patientAge || '',
            gender: rowData.gender || rowData.patientGender || '',
            appointmentDate: rowData.appointmentDate || rowData.date || '',
            appointmentTime: rowData.appointmentTime || rowData.time || '',
            reason: rowData.reason || 'Doctor not available',
            centerId: rowData.centerId,
            slotId: rowData.slotId||"",
            mdpAppointmentId: rowData.mdpAppointmentId || '',
            partnerId: rowData.partnerId ||""
        });
        
        setRescheduleModalOpen(true);
        setAvailableSlotsData(null);
        setSlotsError(null);

        setIsLoadingSlots(true);

    try {
      const response = await getTimeSlots(rowData.partnerId, rowData.doctorPracticeId, rowData.centerId)

    //   console.log('Available slots response:', response);

      // Check if API call was successful
      if (response) {
        setAvailableSlotsData(response);
        setSlotsError(null);
      } else {
        // API returned but with error
        setSlotsError(response.message || 'Failed to load available slots');
        toast.error(response.message || 'Failed to load available slots');
      }
    } catch (error) {
      // Network error or API error
      console.error('Error fetching available slots:', error);
      setSlotsError('Unable to load available slots. Please try again.');
      toast.error('Unable to load available slots. Please try again.');
    } finally {
      setIsLoadingSlots(false);
    }
    };

    const openChangeCentreModal = async (rowData) => {
        
        setSelectedAppointment({
            rid: rowData.requestId || rowData.rid || '',
            patientName: rowData.patientName || rowData.userName || '',
            partner: rowData.sponsorName || rowData.partner || '',
            centre: rowData.centreName || rowData.centre || '',
            address: rowData.centreAddress || rowData.address || '',
            doctor: rowData.doctorName || rowData.doctor || '',
            age: rowData.age || rowData.patientAge || '',
            gender: rowData.gender || rowData.patientGender || '',
            appointmentDate: rowData.appointmentDate || rowData.date || '',
            appointmentTime: rowData.appointmentTime || rowData.time || '',
            reason: rowData?.reason || 'Changing centre',
            centerId: rowData?.centerId,
            partnerId: rowData?.partnerId || "",
            doctorOpdCharge: Number(rowData?.doctorOpdCharge) || null,
            doctorPracticeId: rowData?.doctorPracticeId || null,
            // amount is total amount paid by user when booking consulatation, taken from cashless_Dental_request_transactions table
            amount : Number(rowData?.amount) || null
        });

        setChangeCentreModalOpen(true);
        setIsLoadingChangeCentre(true);

        try {
          // Fetch both APIs in parallel
        const [centresResponse, dateAndTimeSlots] = await Promise.all([
        fetchDentalCenterAndDoctorLists(rowData.requestId || rowData.rid, rowData.partnerId, rowData.doctorPracticeId, rowData.centerId),
        getTimeSlots(rowData.partnerId, rowData.doctorPracticeId, rowData.centerId)
        ]);

      setCentresAndDoctorsData(centresResponse);
      setAvailableSlotsData(dateAndTimeSlots);
  } catch (error) {
    console.error('Error fetching data:', error);
    toast.error('Failed to load data');
  } finally {
    setIsLoadingChangeCentre(false);
  }
    };

    const handleConfirmAppointment = async () => {
    if (!selectedAppointment?.rid) {
        toast.error("Invalid appointment selection.");
        return;
    }

    console.log('Confirming appointment:', selectedAppointment);

    const requestType = Number(selectedAppointment?.mdpAppointmentId) > 0 ? 'mdp' : 'non-mdp';

    try {
        // Trigger the API call
        const response = await confirmAppointmentAPI(selectedAppointment.rid, requestType);

        if (response?.status === 'success' || response?.message === 'success') {
            toast.success('Appointment confirmed successfully!' ,{
                    backgroundColor: '#2e7d32',
            });
            
            // Refresh data and close UI
            await fetchTableData(); 
            setConfirmAppointmentModalOpen(false);
        } else {
            // Handle case where API returns 200 OK but has an internal error message
            toast.error(response?.message || 'Failed to confirm appointment');
        }

    } catch (error) {
        console.error("Confirmation Error:", error);
        // Extract error message if available from server, otherwise use default
        const errorMessage = error.response?.data?.message || 'Confirmation failed, please try again';
        toast.error(errorMessage);
    }
};

 
  const handleRescheduleAppointment = async (rescheduleData) => {
    console.log('Rescheduling appointment with data:', rescheduleData, selectedAppointment);

    try {
      // Call ops side reschedule API of backend-ts
      const response = await rescheduleAppointment({
        requestId: rescheduleData.requestId,
        reason: rescheduleData.reason,
        date: rescheduleData.newAppointmentDate,
        slotId: rescheduleData.newAppointmentSlotId,
        centerId:selectedAppointment.centerId,


      });


      console.log('Reschedule response:', response);

      if (response) {
        toast.success(response?.message);
        
        // Refresh table data
        fetchTableData();
        
        // Close modal
        setRescheduleModalOpen(false);
        
        // Clear state
        setSelectedAppointment(null);
        setAvailableSlotsData(null);
      } else {
        toast.error(response.message || 'Failed to reschedule appointment');
      }
    } catch (error) {
      console.error('Error rescheduling appointment:', error,error.response.data.errorMessage);
      toast.error(error?.response?.data?.errorMessage || 'Something went wrong. Please try again.');
    }
  };
    const handleChangeCentre = async (changeCentreData) => {
        // added useRef to avoid multiple api calls and performance when user continuosly keep clicking change center modal
        if (isProcessingRef.current) return; 
        isProcessingRef.current = true;


        try {
        const response = await changeDentalCenter(changeCentreData)
         if (response){
            toast.success('Centre changed successfully!');
            fetchTableData();
            setChangeCentreModalOpen(false);
           }else{
            toast.error('Center update failed')
           }
        } catch (err) {
            toast.error( err?.response?.data?.errorMessage || err?.message || 'Centre change Failed!');
            setChangeCentreModalOpen(false);
        }finally{
              isProcessingRef.current = false;
        }
    };

    const openRequestCommentModal = (requestId) => {
        setShowCommentModal(true)
        setCommentModalRequestId(requestId)
    }

    const cancelOpenModal = (requestId, mdpAppointmentId) => {
        console.log(requestId, mdpAppointmentId, '[requestId, mdpAppointmentId]');
        setCancelModalIsOpen(true)
        setRequestId(requestId)
        setMdpRequestId(mdpAppointmentId)
    }

    const confirmOpenModal = (requestId) => {
        console.log({ requestId }, '[confirmOpenModal]');
        setConfirmModalIsOpen(true)
        setRequestId(requestId)
    }

    const closeConfirmModal = () => {
        setConfirmModalIsOpen(false);
    }

    const cancelCloseModal = () => {
        setCancelModalIsOpen(false)
    }

    const submitCancelModal = (reason) => {
        console.log({ reason }, '[reason, remarks]');
        if (!reason) {
            return toast.error('Please select a reason to continue')
        }
        return cancelDentalModal(requestId, reason)
        .then((response) => {
            console.log({response}, '[response]');
            if (response.message === 'success') {
                setMdpRequestId(null)
                setRequestId(null)
                toast.success('Request Canceled Successfully')
            } else {
                toast.error(`${response.message}`);
            }
        })
        .catch(() => toast.error('Cancel request failed, please try again'))
    }

    const submitCompletedAppointment = () => {
        console.log(requestId, '[requestId]');
        if(!requestId) {
            return toast.error('No requestId found');
        }
        return markAppointmentComplete(requestId).then((response) => {
            console.log({ response }, '[markAppointmentComplete][response]')
            setRequestId(null)
            if (response.message === 'success') {
                toast.success('Procedure Marked Completed');
            } else {
                toast.error(`${response.message}`);
            }
        }).catch((error) => toast.error(`Something went wrong - ${requestId} ${error}`))
    }

    const fetchTableData = (currPage, currentPageSize, orderBy, orderDir, claimFilter) => {
        const valid = value => typeof value === 'number';
        const dateCheck = (date) => {
            return !date ? date : moment(date).format('YYYY-MM-DD')
        }
        setIsLoading(true)
        const params = { 
            page: valid(currPage) ? currPage : currentPage,
            draw: valid(currentPageSize) ? currentPageSize : pageSize,
            requestId: requestIdFilter,
            appointmentTimeFilter: appTimeFilter,
            appTimeFilter,
            appointmentDateFilterEndDate: dateCheck(appointmentDateFilter.endDate),
            appointmentDateFilterStartDate: dateCheck(appointmentDateFilter.startDate),
            requestDateFilterStartDate: dateCheck(requestDateFilter.startDate),
            requestDateFilterEndDate: dateCheck(requestDateFilter.endDate),
            search: makeSearch,
            sponsorFilter: sponsorFilter,
            partnerName: partnerNameFilter,
            mdpAppointmentFilter: mdpAppointmentFilter,
            statusFilter: statusFilter,
        }
        if (orderBy && orderDir) {
            params.orderBy = orderBy
            params.orderDir = orderDir
        }
        if (claimFilter) {
            params.claimedByFilter = claimFilter
        }
        return getCashlessDentalRequests(params)
            .then((res) => {
                setIsLoading(false)
                const allData = res.rows
                setData(allData)
                setTotalRecords(res.count)
                setPages(Math.ceil(res.count / (valid(currentPageSize) ? currentPageSize : pageSize)))
            }).catch((err) => {
                console.log({err}, '[err]')
                setIsLoading(false)
            })
    }

    const onFetchData = (state) => {
        let orderBy, orderDir, claimFilter
        if (state.sorted.length) {
            orderBy = state.sorted[0].id
            orderDir = state.sorted[0].desc ? 'DESC' : 'ASC'
        }
        state.filtered.forEach((filter) => {
            if (filter.id === 'opsUserName') {
                claimFilter = filter.value
            }
        });

        fetchTableData(state.page, state.pageSize, orderBy, orderDir, claimFilter);
        setCurrentPage(state.page)
        setPageSize(state.pageSize)
    };

    const handleSearchBar = (event) => {
        const { value } = event.target
        if (event.key === 'Enter') {
            setMakeSearch(value)
        }
    }

    const openClaimRequestButton = (requestId) => {
        setShowClaimModal(true)
        setClaimRequestId(requestId)
    }

    const closeClaimRequestButton = () => {
        setShowClaimModal(false)
        setClaimRequestId(null)
    }

    useAfterInitialEffect(() => {
        fetchTableData()
    }, [
        requestIdFilter,
        statusFilter,
        makeSearch,
        sponsorFilter,
        partnerNameFilter,
        mdpAppointmentFilter,
        appointmentDateFilter,
        requestDateFilter,
        appTimeFilter,
    ])

    const cashlessDental = tableColumns({
        dispatch, 
        showDentalRequestModal, 
        setRequestIdFilter, 
        setStatusFilter, 
        setRequestSponsorFilter,
        setPartnerNameFilter,
        openRequestCommentModal,
        setRequestMdpAppointmentFilter, 
        setAppointmentDateFilter,
        setRequestDateFilter, 
        setAppTimeFilter, 
        cancelOpenModal, 
        confirmOpenModal,
        openClaimRequestButton, 
        closeClaimRequestButton,
        openConfirmAppointmentModal,
        openRescheduleAppointmentModal,
        openChangeCentreModal,
    }, {
        statusFilter
    }, [statusFilter])

    const closeRequestCommentModal = () => {
        setShowCommentModal(false)
        setCommentModalRequestId(null)
    }

    return (
      <OuterComponent>
        <NavBar />
        <PaddedContainer className='pt-4 mt-5'>
            <Row>
                <div className='col-6'>
                    <div className='row'>
                        <div className='col-8'>
                            <SearchBox>
                                <SearchBoxInput
                                    ref={searchInputRef} 
                                    placeholder='Search...'
                                    type='text'
                                    onKeyDown={handleSearchBar}
                                />
                                <SearchBoxContent>{totalRecords} records</SearchBoxContent>
                            </SearchBox>
                        </div>
                        <div className="col-1">
                            {isLoading ? (
                                <LoadingComponent />
                            ) : (
                                <button
                                onClick={() => setMakeSearch(searchInputRef.current.value)}
                                className="btn btn-primary"
                                >
                                <FaSearch />
                                </button>
                            )}
                        </div>
                    </div>
                </div>
                <div className='col-6 d-flex flex-nowrap justify-content-end align-items-center' style={{ gap: '0.5rem' }}>
                    <ButtonGroup size='sm'>
                        <DownloadCsv
                            isCashlessDental
                            callback={() => getCashlessDentalRequests({
                                draw: totalRecords,
                                search: makeSearch
                            })}
                        />
                    </ButtonGroup>
                    <ButtonGroup size='sm'>
                        <button
                            type='button'
                            className='btn btn-secondary'
                            onClick={() => setShowSpocActivity(true)}
                        >
                            Show SPOC Activity
                        </button>
                    </ButtonGroup>
                    <ButtonGroup size='sm'>
                        <DownloadCsv
                            isCashlessDental
                            callback={() => getCashlessDentalRequests({
                                draw: totalRecords,
                                search: makeSearch,
                                statusFilter: statusFilter,
                                sponsorFilter: sponsorFilter,
                                mdpAppointmentFilter: mdpAppointmentFilter,
                                requestIdFilter: requestIdFilter,
                                requestDateFilterStartDate: requestDateFilter.startDate,
                                requestDateFilterEndDate: requestDateFilter.endDate,
                                appointmentDateFilterStartDate: appointmentDateFilter.startDate,
                                appointmentDateFilterEndDate: appointmentDateFilter.endDate,
                                appTimeFilter: appTimeFilter,
                                itemBreakdown: true,
                            })}
                            downloadButtonText={'Dental Breakdown'}
                        />
                    </ButtonGroup>
                </div>
            </Row>
        </PaddedContainer>
        <FoldableTable
            data={data}
            columns={cashlessDental}
            loading={isLoading}
            filterable
            manual
            pages={pages}
            showPaginationTop
            className="-striped -highlight"
            onFetchData={onFetchData}
            pageSizeOptions={[10, 20, 50, 100]}
            defaultSorted={[
                {
                    id: 'requestId',
                    desc: true
                }
            ]}
            SubComponent={(row) => (
                <SubContainer 
                    requestId={row.original.requestId}
                    userId={row.original.userId}
                    type= {'dental'}
                />
            )}
        />

        <DentalRequestDetails 
            details={stateDetails}
            onClose={() => dispatch(hideDentalRequestModal())}
            isOpen={stateDetails && stateDetails.requestId}
            key={stateDetails?.requestId}
        />

        <DentalCommentModal
            requestId={commentModalRequestId}
            isOpen={showCommentModal}
            onClose={closeRequestCommentModal}
            onComplete={fetchTableData}
        />

        <SpocActivityModal
            isOpen={showSpocActivity}
            onClose={() => setShowSpocActivity(false)}
        />

        <DentalModalCancellation 
            modalIsOpen={cancelModalIsOpen}
            openModal={cancelOpenModal}
            closeModal={cancelCloseModal}
            submitModal={submitCancelModal}
            onComplete={fetchTableData}
            requestId={requestId}
        />

        <MarkDentalAppointmentComplete 
            modalIsOpen={confirmModalIsOpen}
            openModal={confirmOpenModal}
            closeModal={closeConfirmModal}
            onComplete={fetchTableData}
            submitModal={submitCompletedAppointment}
            requestId={requestId}
        />

        <DentalClaimModal
            isOpen={showClaimModal}
            onClose={closeClaimRequestButton}
            requestId={claimRequestId}
            onComplete={fetchTableData}
        />

        {/* NEW: Three Appointment Modals */}
        <ConfirmAppointmentModal
            modalIsOpen={confirmAppointmentModalOpen}
            closeModal={() => setConfirmAppointmentModalOpen(false)}
            submitModal={handleConfirmAppointment}
            appointmentData={selectedAppointment}
            onComplete={fetchTableData}
        />

       <RescheduleAppointmentModal
        modalIsOpen={rescheduleModalOpen}
        closeModal={() => {
          setRescheduleModalOpen(false);
          setSelectedAppointment(null);
          setAvailableSlotsData(null);
          setSlotsError(null);
        }}
        submitModal={handleRescheduleAppointment}
        appointmentData={selectedAppointment}
        availableSlotsData={availableSlotsData}
        isLoadingSlots={isLoadingSlots}
        slotsError={slotsError}
       />


        <ChangeCentreModal
            modalIsOpen={changeCentreModalOpen}
            closeModal={() => setChangeCentreModalOpen(false)}
            submitModal={handleChangeCentre}
            appointmentData={selectedAppointment}
            onComplete={fetchTableData}
            centresAndDoctorsData={centresAndDoctorsData}
            availableSlotsData={availableSlotsData}
            isLoading={isLoadingChangeCentre}
        />

        
    </OuterComponent>
  )
}

const matchStateToProps = (state) => ({
    cashlessDentalDetails: state.cashlessDental
})

export default connect(matchStateToProps)(CashlessDental)